import { render, staticRenderFns } from "./SupporterSearchResults.vue?vue&type=template&id=b85bf114&scoped=true&"
import script from "./SupporterSearchResults.vue?vue&type=script&lang=js&"
export * from "./SupporterSearchResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85bf114",
  null
  
)

export default component.exports